import { render, staticRenderFns } from "./admin-package-create.vue?vue&type=template&id=5fb55280&scoped=true&"
import script from "./admin-package-create.vue?vue&type=script&lang=js&"
export * from "./admin-package-create.vue?vue&type=script&lang=js&"
import style0 from "./admin-package-create.vue?vue&type=style&index=0&id=5fb55280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb55280",
  null
  
)

export default component.exports